import React from 'react';
import { Hero } from './components/Hero';
import { TestimonialStrip } from './components/TestimonialStrip';
import { Problema } from './components/Problema';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { Oferta } from './components/Oferta';
import { SistemaTotal } from './components/SistemaTotal';
import { Testimonios } from './components/Testimonios';
import { CostoDeNoTenerlo } from './components/CostoDeNoTenerlo';
import { Garantia } from './components/Garantia';
import { Faq } from './components/Faq';
import { CierreFinal } from './components/CierreFinal';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel('1386464580182190');
  return <div className="w-full bg-forest-900 font-sans" data-id="element-0" data-mp="28suw6sn6u7od">
      <Hero data-id="element-1" data-mp="23vkzcrxgytqi" />
      <main data-id="element-2" data-mp="23w4e5zrtp20b">
        <TestimonialStrip data-id="element-3" data-mp="23u9qidp62vsj" />
        <Problema data-id="element-4" data-mp="23v2uj6wqr76z" />
        <Tomos data-id="element-5" data-mp="23ti5fwt74ggi" />
        <Bonos data-id="element-6" data-mp="3ik7e6ay3c1o0" />
        <Oferta data-id="element-7" data-mp="3ikqy1x7ax04o" />
        <SistemaTotal data-id="element-8" data-mp="3ij66mgga9xb1" />
        <Testimonios data-id="element-9" data-mp="3ijpef4c7z5bc" />
        <CostoDeNoTenerlo data-id="element-10" data-mp="3mljaezbgzl56" />
        <Garantia data-id="element-11" data-mp="3mkre1ma1tjdu" />
        <Faq data-id="element-12" data-mp="3mk868ye44bdj" />
        <CierreFinal data-id="element-13" data-mp="3mjzpgvevclx2" />
      </main>
      <Footer data-id="element-14" data-mp="3rc9dg5wfbbwp" />
      <PurchasePopup data-id="element-15" data-mp="3rbra6pbcfxfa" />
    </div>;
}